import * as $runtime from "../runtime.js";
import * as Data$dArray from "../Data.Array/index.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dSet from "../Data.Set/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dUnfoldable from "../Data.Unfoldable/index.js";
const toUnfoldable = /* #__PURE__ */ (() => {
  const $0 = Data$dUnfoldable.unfoldableArray.unfoldr(Data$dMap$dInternal.stepUnfoldr);
  return x => $0(Data$dMap$dInternal.$MapIter("IterNode", x, Data$dMap$dInternal.IterLeaf));
})();
const elem = /* #__PURE__ */ (() => {
  const any1 = Data$dSet.foldableSet.foldMap((() => {
    const semigroupDisj1 = {append: v => v1 => v || v1};
    return {mempty: false, Semigroup0: () => semigroupDisj1};
  })());
  return dictEq => x => any1(dictEq.eq(x));
})();
const take = dictOrd => {
  const fromFoldable = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
  return n => x => fromFoldable((() => {
    const $0 = toUnfoldable(x);
    if (n < 1) { return []; }
    return Data$dArray.sliceImpl(0, n, $0);
  })());
};
const restrictKeys = dictOrd => {
  const elem1 = elem(dictOrd.Eq0());
  return map1 => keys => Data$dMap$dInternal.filterKeys(dictOrd)(v => elem1(v)(keys))(map1);
};
const partitionWithKey = dictOrd => {
  const fromFoldable = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
  return p => m => {
    const parts = Data$dArray.partitionImpl(v => p(v._1)(v._2), toUnfoldable(m));
    return {yes: fromFoldable(parts.yes), no: fromFoldable(parts.no)};
  };
};
const mapKeys = dictOrd => {
  const fromFoldable = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
  return f => m => fromFoldable(Data$dFunctor.arrayMap(v => Data$dTuple.$Tuple(f(v._1), v._2))(toUnfoldable(m)));
};
const findWithDefault = dictOrd => d => k => {
  const $0 = Data$dMap$dInternal.lookup(dictOrd)(k);
  return x => {
    const $1 = $0(x);
    if ($1.tag === "Nothing") { return d; }
    if ($1.tag === "Just") { return $1._1; }
    $runtime.fail();
  };
};
const drop = dictOrd => {
  const fromFoldable = Data$dMap$dInternal.fromFoldable(dictOrd)(Data$dFoldable.foldableArray);
  return n => x => fromFoldable((() => {
    const $0 = toUnfoldable(x);
    if (n < 1) { return $0; }
    return Data$dArray.sliceImpl(n, $0.length, $0);
  })());
};
export {drop, elem, findWithDefault, mapKeys, partitionWithKey, restrictKeys, take, toUnfoldable};
